import React from 'react';
import Text from 'components/Text';
import { Column, Row } from 'components/Layout/Grid';
import ProductsTable from 'components/Table/Products';
import { productModel } from 'components/Table/Products/models';
import { useSelector } from 'react-redux';
import { RootState } from 'store/ducks';
import { formatSeller } from 'components/Seller';

const Products: React.FC = () => {
  const user = useSelector((state: RootState) => state.user);

  const pageSize = 10;

  const sellerInfo = user?.customer?.seller;
  const customerBUs = user?.customer?.customerBus;

  return (
    <>
      <Row className="w-100 justify-between">
        <Column>
          <Text size={24} className="color-primary font-bold">
            Consulta de produtos
          </Text>
        </Column>
        {user?.userType === 'customer' && sellerInfo && (
          <Column className="align-center justify-end">
            <Row>
              <Text size={15}>
                Verifique com o seu contato comercial &nbsp;
                {formatSeller(sellerInfo, customerBUs)}&nbsp; o prazo de entrega do produto
              </Text>
            </Row>
          </Column>
        )}
      </Row>
      <Column className="w-100 max-w-lg-100 flex-1">
        <ProductsTable
          model={productModel}
          pageSize={pageSize}
          completeBlankSpaces
        />
      </Column>
    </>
  );
};

export default Products;
